import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawCloseIcon from "./RawCloseIcon.svg.jsx";

const WrongAnswerIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawCloseIcon} {...props} />;
});

export default WrongAnswerIcon;
